/* eslint-disable no-control-regex */
import z from "zod";

import {
  ARABIC_TEXT_WITH_NUMBERS_AND_SIGNS_REGEX,
  ARABIC_TEXT_WITH_NUMBERS_REGEX,
} from "@/utils/constants/arabicRegex";

export const FormSchema = z
  .object({
    nameEn: z
      .string()
      .min(1, { message: "Brand name is required." })
      .max(100, { message: "Brand name must be under 100 characters." })
      .refine(value => /^[\u0000-\u007F]+$/.test(value), {
        message: "Only English letters, numbers and symbols are allowed.",
      })
      .trim(),
    nameAr: z
      .string()
      .min(1, { message: "Brand name is required." })
      .max(100, { message: "Brand name must be under 100 characters." })
      .regex(ARABIC_TEXT_WITH_NUMBERS_AND_SIGNS_REGEX, {
        message: "Only Arabic characters and numbers are allowed.",
      })
      .trim(),
    descriptionEn: z
      .string()
      .max(500, "Max length is 500 characters.")
      .trim()
      .transform(v => (v.trim() === "" ? null : v))
      .nullable()
      .optional(),
    descriptionAr: z
      .string()
      .max(500, "Max length is 500 characters.")
      .refine(v => v.trim() === "" || ARABIC_TEXT_WITH_NUMBERS_REGEX.test(v), {
        message: "Description must contain only Arabic characters.",
      })
      .transform(v => (v.trim() === "" ? null : v))
      .nullable()
      .optional(),

    googleBusinessId: z
      .string()
      .transform(val => (val.trim() === "" ? undefined : val))
      .nullable()
      .optional(),
    country: z.string().min(1, "Country is required."),
    currency: z.string().min(1, "Currency is required."),
    groupId: z.string().optional(),
    legalEntityId: z
      .string()
      .transform(val => (val.trim() === "" ? undefined : val))
      .nullable()
      .optional(),
    id: z.string().optional(),
    mediaItemId: z.string().nullable().optional(),
    logoUrl: z.string().nullable().optional(),
  })
  .superRefine((data, ctx) => {
    if ("groupId" in data && !data.groupId) {
      ctx.addIssue({
        path: ["groupId"],
        code: z.ZodIssueCode.custom,
        message: "Group is required.",
      });
    }
  });

export type BrandFormDetailsType = z.infer<typeof FormSchema>;
